<template>
  <div class="n3">
    <h1 class="n3-title">{{title}}</h1>
    <p class="n3-info">{{info}}</p>

    <div class="n3-content">
      <tiny-tabs v-model="activeName" tab-style="card">
        <tiny-tab-item v-for="(item, index) of groupList" :key="item.name" :title="item.name" :name="index + ''">
          <ul>
            <li v-for="item2 of item.children" :key="item2.name" @click="handleRoute(item2)">
              <div class="n3-bg" v-if="item2.siteMenuDetail == null">
                <div class="n3-masking">
                  <p class="n3-caption"></p>
                  <p class="n3-desc"></p>
                </div>
              </div>
              <div class="n3-bg" v-if="item2.siteMenuDetail != null" :style="(item2.siteMenuDetail.imgUrls != null) ? { backgroundImage:'url('+item2.siteMenuDetail.imgUrls+')'} : ''">
                <div class="n3-masking">
                  <p class="n3-caption">{{item2.siteMenuDetail.title}}</p>
                  <p class="n3-desc">{{item2.siteMenuDetail.subTitle}}</p>
                </div>
              </div>
            </li>
          </ul>
        </tiny-tab-item>
      </tiny-tabs>
    </div>

  </div>
</template>

<script>
import { Tabs, TabItem, Image } from '@opentiny/vue'
import request from '@/utils/request'

export default {
  name: "HomePart2",
  components: {
    TinyTabs: Tabs,
    TinyTabItem: TabItem,
    TinyImage: Image,
  },
  props:['info'],
  data() {
    return {
      currentEnter: null,
      currentLeave: null,
      title: "我们的服务",
      activeName: '0',
      groupList: [],

    };
  },
  created() {
    this.queryServiceList();
  },
  methods: {
    async queryServiceList() {
      const {data} = await request.get("/outSiteMenu/queryServiceList")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.groupList = data.data;
      }
    },

    handleRoute(row){
      debugger
      if(row.jump === '4' || row.jump === '5'){
        window.open(row.path, '_blank');
        return;
      }
      this.$router.push({path: '/page' + row.jump , query: {id: row.id}});
    },
  }
};
</script>

<style scoped>
.n3 {
  text-align: center;
  margin-top: 100px;
  height: 639px;
}
h1 {
  position: relative;
  display: inline-block;
  margin: 0 auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
}
h1::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}
h1::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}
.n3-bg {
  position: relative;
  width: 286px;
  height: 200px;
  display: block;
  margin: auto;
  background-size: cover;
  background-position: 0 0;
  overflow: hidden;
}
.n3-masking {
  position: absolute;
  width: 286px;
  height: 200px;
  transform: translateY(150px);
  background-color: rgba(0, 0, 0, 0.7);
  transition: 0.3s ease-in;
}
.n3-bg :hover {
  transform: translateY(0px);
  transition: 0.3s ease-in;
}

.n3-content{
  margin: 40px auto;
}


.n3-content::after {
  content: "";
  clear: both;
  display: block;

}
.n3-content ul {
  margin: 20px auto;
  width: 1280px;
}
.n3-content ul li {
  float: left;
  width: 286px;
  margin: 0 6px 12px;
}
.n3-caption {
  position: relative;
  display: inline-block;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  margin-top: 15px;
  margin-bottom: 10px;
}
.n3-desc {
  position: relative;
  display: inline-block;
  font-size: 14px;
  color: #ffffff;
  line-height: 25px;
  margin: 10px 20px;
}

.n3-content >>> .tiny-tabs.tiny-tabs--card>.tiny-tabs__header .tiny-tabs__nav{
  float: none!important;
}

.n3-content >>> .tiny-tabs__nav:not(.is-stretch) .tiny-tabs__item__title{
  font-size: 18px;
  padding: 5px 10px;
}


</style>


